import { cn } from "@/lib/utils";
import { ChevronRight } from "lucide-react";
import type { Faq3Category } from "./viewModel";

type Props = {
  brandColor: string;
  categories: Faq3Category[];
  selectedId: number | null;
  onSelect: (id: number) => void;
};

export function Faq3CategoryRail({ brandColor, categories, selectedId, onSelect }: Props) {
  if (categories.length === 0) return null;

  return (
    <nav
      className={cn("w-full shrink-0 rounded-md p-3 min-[640px]:p-4 min-[1024px]:max-w-[220px] min-[1024px]:py-6")}
      style={{ backgroundColor: brandColor }}
      aria-label="FAQ categories"
    >
      <ul className="flex flex-col gap-1 min-[640px]:gap-1.5">
        {categories.map((cat) => {
          const isActive = selectedId === cat.id;
          const text = isActive ? cat.tab.activeText : cat.tab.idleText;
          const bg = isActive ? cat.tab.activeBg : "transparent";
          return (
            <li key={cat.id}>
              <button
                type="button"
                onClick={() => onSelect(cat.id)}
                className={cn(
                  "flex w-full items-center justify-between gap-3 rounded-md px-1.5 py-2 text-left text-base font-semibold transition-colors",
                  isActive && "p-1.5",
                )}
                style={{ backgroundColor: bg, color: text }}
                title={cat.name}
              >
                <span className="min-w-0 flex-1 break-words">{cat.name}</span>
                <ChevronRight className="size-5 shrink-0" style={{ color: text }} aria-hidden />
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
